var _defs, _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconos32PxFase2B1Generic09({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39b54a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICONOS-32PX-FASE-2b.1-GENERIC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.03,
    y: 8.2,
    width: 3.21,
    height: 5.39,
    transform: "translate(-3.71 12.83) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.6,16.81a.54.54,0,1,0-1-.4,2.39,2.39,0,0,0-.17.89h0a2.41,2.41,0,0,0,3.31,2.25.54.54,0,1,0-.4-1,1.33,1.33,0,0,1-.49.1,1.35,1.35,0,0,1-1.35-1.34h0A1.32,1.32,0,0,1,13.6,16.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.69,22.76a6.48,6.48,0,0,1-8.41-8.38.61.61,0,0,0-.35-.8.61.61,0,0,0-.22,0,.62.62,0,0,0-.57.39,7.71,7.71,0,0,0,10,10,.61.61,0,0,0-.45-1.14Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.66,
    y: 15.82,
    width: 3.21,
    height: 5.39,
    transform: "translate(-6.87 20.46) rotate(-45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.89,11.26a1.62,1.62,0,0,0-2.29,0l-3.05,3.05a1.62,1.62,0,0,0-.31,1.84l-.58.58a.54.54,0,1,0,.76.76l.57-.57h0a1.62,1.62,0,0,0,1.84-.32l3.05-3.05A1.62,1.62,0,0,0,20.89,11.26ZM20.32,13a.81.81,0,1,1,0-1.14A.81.81,0,0,1,20.32,13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.4,20.48a3.64,3.64,0,0,1-5-3.38h0a3.62,3.62,0,0,1,.25-1.33.54.54,0,1,0-1-.39,4.69,4.69,0,0,0-.32,1.72h0a4.72,4.72,0,0,0,6.45,4.38.54.54,0,0,0-.4-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconos32PxFase2B1Generic09);
export default __webpack_public_path__ + "static/media/ICONOS-32PX-FASE-2b.1-GENERIC-09.8818e412a8d1bdd442767f5f895d55e7.svg";
export { ForwardRef as ReactComponent };